import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";

export const NewsletterSignup = ({ dark = false, compact = false, testid = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email, website: hp });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const muted = dark ? "text-shell/70" : "text-muted-foreground";
  return (
    <div data-testid={testid} className={compact ? "" : `grid grid-cols-1 gap-6 p-8 md:grid-cols-[1fr_minmax(0,420px)] md:items-center md:p-10 ${dark ? "bg-ocean text-shell" : "border border-foreground/15 bg-sand/40"}`}>
      {!compact && (
        <div>
          <p className="eyebrow flex items-center gap-2 text-terracotta"><Mail size={14} /> Wochenend-Newsletter</p>
          <h3 className="mt-2 font-display text-2xl md:text-3xl">Die Kompass-Tipps jeden Donnerstag im Postfach</h3>
          <p className={`mt-2 text-sm ${muted}`}>Highlights, Tipps für drinnen und draußen, Wetter und Niedrigwasser – kostenlos, jederzeit abbestellbar.</p>
        </div>
      )}
      {done ? (
        <p className="font-sub text-sm" data-testid={`${testid}-done`}>Fast geschafft! Wir haben dir eine E-Mail geschickt – bitte bestätige darin deine Anmeldung.</p>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          {compact && <p className="eyebrow text-sage">Wochenend-Newsletter</p>}
          <div className="flex gap-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="deine@email.de" aria-label="E-Mail-Adresse" data-testid={`${testid}-email`}
              className={`h-11 min-w-0 flex-1 border px-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta ${dark ? "border-white/25 bg-white/10 text-shell placeholder:text-shell/50" : "border-input bg-white"}`} />
            <input tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden="true" />
            <button type="submit" disabled={busy} data-testid={`${testid}-submit`}
              className="lift flex h-11 shrink-0 items-center gap-2 bg-terracotta px-4 font-sub text-sm text-white hover:bg-terracotta/90 disabled:opacity-60">
              {busy && <Loader2 size={15} className="animate-spin" />} Anmelden
            </button>
          </div>
          <p className={`text-xs ${muted}`}>Mit der Anmeldung stimmst du dem wöchentlichen Versand zu, inklusive eines gekennzeichneten Unterkunfts-Tipps (Anzeige). Abmeldung jederzeit. Infos in der <Link to="/datenschutz#newsletter" className="underline">Datenschutzerklärung</Link>.</p>
        </form>
      )}
    </div>
  );
};
